import "./showOrderDetailsSwitch.less";
import React from "react";
import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";

interface ShowOrderDetailsSwitchProps {}

const ShowOrderDetailsSwitch: React.FC<ShowOrderDetailsSwitchProps> = function (props) {
    const orderManagementStore = useOrderManagementStore();

    return (
        <Checkbox
            className="show-order-detail-switch-container"
            style={{ fontSize: 12 }}
            checked={orderManagementStore.storage.isShowAllOrderDetails}
            onChange={(event: CheckboxChangeEvent) => {
                const checked = event.target.checked;

                const allOrderIds = orderManagementStore.table.orders.map((order) => order.id);
                orderManagementStore.storage.batchClearShowOrderDetails(allOrderIds);

                if (checked) {
                    orderManagementStore.storage.showAllOrderDetails();
                } else {
                    orderManagementStore.storage.hideAllOrderDetails();
                }
            }}
        >
            <span style={{ userSelect: "none" }}>展开详情</span>
        </Checkbox>
    );
};

export default observer(ShowOrderDetailsSwitch);
